/**
 * Servicios de «Personas y roles» y «Distribuidores por corregir» (ERP F1, B2).
 */

import api from './api.js';

const limpio = (params = {}) => {
  const out = {};
  Object.keys(params).forEach((k) => {
    if (params[k] !== '' && params[k] !== null && params[k] !== undefined && params[k] !== false) out[k] = params[k];
  });
  return out;
};

export default {
  resumen: () => api.get('/personas-erp/resumen'),
  listar: (params) => api.get('/personas-erp', limpio(params)),
  obtener: (id) => api.get(`/personas-erp/${id}`),
  crear: (data) => api.post('/personas-erp', data),
  actualizar: (id, data) => api.put(`/personas-erp/${id}`, data),
  eliminar: (id) => api.delete(`/personas-erp/${id}`),
  restaurar: (id) => api.post(`/personas-erp/${id}/restaurar`),
  distribuidores: () => api.get('/personas-erp/selector/distribuidores'),
  agentes: (params) => api.get('/personas-erp/selector/agentes', limpio(params)),
  calidad: () => api.get('/personas-erp/calidad'),
  corregir: (documento, id, data) => api.put(`/personas-erp/calidad/${documento}/${encodeURIComponent(id)}`, data)
};
